import React from 'react';
import classNames from 'classnames';
import { LISTING_PACKAGE, ListingPackage } from 'models/Listing';
import GetBuyers from '../../components/GetBuyers';

import './ListingOptions.styles.scss';

const OPTIONS: ListingPackage[] = [
  LISTING_PACKAGE.GOLD,
  LISTING_PACKAGE.SILVER,
  LISTING_PACKAGE.BRONZE,
  LISTING_PACKAGE.NO_PACKAGE,
];

type ListingOptionsProps = {
  className?: string;
};

const ListingOptions: React.FC<ListingOptionsProps> = (props) => {
  const { className } = props;

  const classes = classNames('listing-options', 'lcw-page', className);

  return <GetBuyers className={classes} options={OPTIONS} />;
};

export default ListingOptions;
